<div class="modal">
    <div class="content-strip">
        <mat-card appearance="outlined" class="card" *ngIf="friendRequest">
            <mat-card-header class="card-header">
                <mat-card-title>Caballus-Friend Action</mat-card-title>
            </mat-card-header>
            <mat-card-content>
                <div class="details">
                    <div class="detail">
                        <span *ngIf="isBlocked(friendRequest.friendStatus)">
                            {{ friendRequest.friendIdentity?.label }}
                            This user is blocked from sending you friend invites. Would you like to
                            unblock this user?
                        </span>
                        <span *ngIf="!isBlocked(friendRequest.friendStatus)">
                            {{ friendRequest.friendIdentity?.label }} Would you like to block this
                            user?
                        </span>
                    </div>
                </div>
                <div class="buttons" *ngIf="isBlocked(friendRequest.friendStatus)">
                    <button mat-button class="large-round spinner center" (click)="unblockFriend()">
                        Yes
                    </button>
                    <button mat-button class="large-round spinner center" (click)="cancel()">
                        No
                    </button>
                </div>
                <div class="buttons" *ngIf="!isBlocked(friendRequest.friendStatus)">
                    <button mat-button class="large-round spinner center" (click)="blockFriend()">
                        Block
                    </button>
                    <button mat-button class="large-round spinner center" (click)="cancel()">
                        Cancel
                    </button>
                </div>
            </mat-card-content>
        </mat-card>
    </div>
</div>
